import Vue from "vue";
import Router from "vue-router";
import paths from "./paths";
import requestspaths from "./requests";
import errorpaths from "./error";
//import 'nprogress/nprogress.css'
import users from "./users";
import audit from "./audit";
import store from "../store";
import librarypaths from "@/modules/library/router/index";

Vue.use(Router);
const router = new Router({
  base: "canal-etica",
  mode: "history",
  linkActiveClass: "active",
  routes: paths.concat(users, audit, errorpaths, requestspaths, librarypaths),
});

router.beforeEach(async (to, from, next) => {
  //NProgress.start();

  if (to.query && to.query.goto) {
    store.commit("setGoto", to.query.goto);
  }
  let gotTo = null;
  try {
    gotTo = await store.getters.getGoto();
  } catch (error) {}
  if (gotTo || gotTo === "") {
    try {
      store.commit("setGoto", null);
    } catch (error) {}

    next({ path: gotTo });
    return;
  }
  next();
});

router.afterEach((to, from) => {
  //NProgress.done();
});

export default router;
